import _axios from '@/utils/request'

// 获取用户信息列表
export function postAppUserList (param) {
    return _axios('post', `/ms-shulan-hospital/v1/app_user/list`, param)
}

// 查看用户信息和就诊人
export function getAppUserByIuid (iuid) {
    return _axios('get', `/ms-shulan-hospital/v1/app_user/iuid/${iuid}`)
}

// 编辑个人信息
export function postAppUserUpdate (param) {
    return _axios('post', `/ms-shulan-hospital/v1/app_user/user_base/update`, param)
}

// 删除就诊人
export function postDelAppUser (contactId) {
    return _axios('post', `/ms-shulan-hospital/v1/app_user/del/${contactId}`)
}

// 用户列表 -  修改密码
export function postChangePassword (params, code, phone) {
    return _axios('post', `/ms-shulan-hospital/v1/app_user/app/update_pwd?code=${code}&phone=${phone}`, params)
}

// 用户列表 - 获取验证码
export function postSendVerification (param) {
    return _axios('post', `/ms-shulan-hospital/v1/doctor/sendChangeVerification`, param)
}
